import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import {
  Form
} from "../Form";
import { useDispatch, useSelector } from "react-redux";
import { StandardConst } from "../../Services/StandardConst";

import { Autocomplete, Avatar, Box, Checkbox, TextField } from "@mui/material";
import { WSSuccessAlert } from "../../Services/WSAlert";

const { forwardRef, useState, useImperativeHandle } = React;
const AssignShift = (prop, ref) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [Shiftdata, setShiftData] = useState({ Permission: {} });
  const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
  const [userOrEmployeeList, setUserOrEmployeeList] = useState([]);
  const [selectedPeople, setSelectedPeople] = useState(null);

  useImperativeHandle(ref, () => ({
    openModal: async (id) => {
      GetAssgnmets(id);
      const data = await WebService({
        endPoint: `CommonUtility/Edit/ShiftTiming?WorkShiftId=${id || 0}`,
        dispatch,
      });
      setShiftData(data[0]);
      setShow(true);
    },
  }));

  const GetAssgnmets = async (id) => {
    try {
      const data = await WebService({
        endPoint: `ShiftTiming/GetAssignments?WorkShiftId=${id || 0}`,
        dispatch,
      });
      setSelectedPeople(data);
    } catch {
      console.log("error occured");
    }
  };

  const handleClose = () => setShow(false);
  const fetchAllEssentialInformation = async () => {
    const data = {
      Employees: await WebService({
        endPoint: `Visitor/fetchAllEmployees`,
        dispatch,
      }),
      Users: await WebService({
        endPoint: `CommonUtility/fetchAll/users?CompanyId=${
          companyInfo.CompanyId || 0
        }`,
        dispatch,
      }),
    };
    const emplist = data.Employees?.filter((r) => r.FullName !== null)?.map(
      (res) => {
        return {
          ...res,
          EmployeeId: res.EmployeeId,
          heading: res.FullName,
          description: res.Designation,
          avatar: `${StandardConst.apiBaseUrl}/uploads/${res.ProfileImage}`,
        };
      }
    );
    const userslist = data.Users?.filter((r) => r.FullName !== null)?.map(
      (res) => {
        return {
          ...res,
          UserId: res.UserId,
          heading: res.FullName,
          description: res.Designation,
          avatar: `${StandardConst.apiBaseUrl}/uploads/${res.ProfileImage}`,
        };
      }
    );
    const combinedDetails = [...emplist, ...userslist];
    setUserOrEmployeeList(combinedDetails);
  };


  useEffect(() => {
    fetchAllEssentialInformation();
  }, []);

  const onSubmit = async (data) => {
    await WebService({
      endPoint: "ShiftTiming/assign-users-to-shift",
      body: {
        ShiftId: Shiftdata.WorkShiftId,
        assignments : selectedPeople
      },
      dispatch,
    });
    WSSuccessAlert(
          "Success", 
          `Assignment request completed successfully.`
        );
    handleClose();
    prop.callBackEvent();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Assign Shift</Modal.Title>
      </Modal.Header>
      <Form
        defaultValues={selectedPeople}
        onSubmit={onSubmit}
        // validationSchema={schema}
      >
        <Modal.Body className="p-4">
          <div className="row">
            <div className="col-md-12">
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={userOrEmployeeList}
                getOptionLabel={(option) => option?.heading || ""}
                value={selectedPeople}
                onChange={(e, newValue) => setSelectedPeople(newValue)}
                isOptionEqualToValue={(option, value) => {
                  const sameEmployee =
                    option.EmployeeId && value.EmployeeId
                      ? option.EmployeeId === value.EmployeeId
                      : false;

                  const sameUser =
                    option.UserId && value.UserId
                      ? option.UserId === value.UserId
                      : false;

                  return sameEmployee || sameUser;
                }}
                renderOption={(props, option, { selected }) => (
                  <Box component="li" {...props} key={JSON.stringify(option)}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    <div className="d-flex align-items-center">
                      <div className="me-2">
                        {option?.avatar ? (
                          <Avatar
                            alt={option?.heading?.charAt(0)}
                            src={option?.avatar}
                          />
                        ) : option.heading ? (
                          <Avatar alt="no-image">
                            {option?.heading?.charAt(0)}
                          </Avatar>
                        ) : null}
                      </div>
                      <div>
                        <div>{option?.heading}</div>
                        <div style={{ fontSize: "12px", color: "#777" }}>
                          {option?.description}
                        </div>
                      </div>
                    </div>
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select users or employees"
                  />
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="btnPermissionSubmit"
            variant="outline-primary"
            type="submit"
          >
            Assign Shift
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default forwardRef(AssignShift);
